/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ValueOperation extends BaseEntity implements Wars.Domain.Model.Calculations.ValueOperation {
        constructor() {
            super();
        }

        operator: Wars.Domain.Model.Codes.Enums.ValueOperator;
        variableType: Wars.Domain.Model.Codes.Enums.VariableType;
        operands: Wars.Domain.Model.Calculations.Operand[];
        onlyAllowListOperands: boolean;

        public getVariableTypeSymbol(): string {
            switch (this.variableType) {
                case Wars.Domain.Model.Codes.Enums.VariableType.String:
                    return "S";
                case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                    return "I";
                case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                    return "Dc";
                case Wars.Domain.Model.Codes.Enums.VariableType.DateTime:
                    return "Dt";
                case Wars.Domain.Model.Codes.Enums.VariableType.Date:
                    return "D";
                case Wars.Domain.Model.Codes.Enums.VariableType.Time:
                    return "T";
                case Wars.Domain.Model.Codes.Enums.VariableType.Boolean:
                    return "B";
                case Wars.Domain.Model.Codes.Enums.VariableType.Code:
                    return "C";
                default:
                    return "?";
            }
        }

        public getVariableTypeName(): string {
            switch (this.variableType) {
                case Wars.Domain.Model.Codes.Enums.VariableType.String:
                    return "String";
                case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                    return "Integer";
                case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                    return "Decimal";
                case Wars.Domain.Model.Codes.Enums.VariableType.DateTime:
                    return "Date/Time";
                case Wars.Domain.Model.Codes.Enums.VariableType.Date:
                    return "Date";
                case Wars.Domain.Model.Codes.Enums.VariableType.Time:
                    return "Time";
                case Wars.Domain.Model.Codes.Enums.VariableType.Boolean:
                    return "Boolean";
                case Wars.Domain.Model.Codes.Enums.VariableType.Code:
                    return "Code";
                default:
                    return "Unknown";
            }
        }
    }
}